(ns common.schema.entities.contact-list
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common]))

(def schema
  (concat
   (su/text-simple-field :contact-list/title
                         "Title"
                         {:authorization su/access-user-user})

   (su/text-simple-field :contact-list/description
                         "Description"
                         {:authorization su/access-user-user})

   (su/multi-ref-field :contact-list/members
                       "Members"
                       [:entity.type/account :entity.type/person]
                       {:authorization su/access-user-user
                        :default-field-visibility   :in-use-disabled})))
